export default class  RankingSalesReportActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_RANKINGSALES='GET_HELPER_RANKINGSALES';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type:  RankingSalesReportActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type:  RankingSalesReportActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type:  RankingSalesReportActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type:  RankingSalesReportActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type:  RankingSalesReportActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type:  RankingSalesReportActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type:  RankingSalesReportActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type:  RankingSalesReportActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type:  RankingSalesReportActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type:  RankingSalesReportActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type:  RankingSalesReportActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type:  RankingSalesReportActions.GET_HELPER_RANKINGSALES,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type:  RankingSalesReportActions.ERROR_SERVER,
      payload: error
    };
  }
  
}